import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PublicLayout from '../layouts/PublicLayout';
import AdminLayout from '../layouts/AdminLayout';
import ScheduleView from '../pages/public/ScheduleView';
import Login from '../pages/admin/Login';
import ProtectedRoute from '../components/ProtectedRoute';
import LoadingSpinner from '../components/LoadingSpinner';

// Lazy load admin components for code splitting
const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));
const SessionManager = lazy(() => import('../pages/admin/SessionManager'));
const RoomManager = lazy(() => import('../pages/admin/RoomManager'));
const AttendeeManager = lazy(() => import('../pages/admin/AttendeeManager'));
const QRScanner = lazy(() => import('../pages/admin/QRScanner'));
const AttendanceTracker = lazy(() => import('../pages/admin/AttendanceTracker'));
const AnalyticsDashboard = lazy(() => import('../pages/admin/AnalyticsDashboard'));
const AnnouncementComposer = lazy(() => import('../pages/admin/AnnouncementComposer'));

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<ScheduleView />} />
      </Route>
      
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="login" element={<Login />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <AdminDashboard />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="sessions"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <SessionManager />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="rooms"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <RoomManager />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="attendees"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <AttendeeManager />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="checkins"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <QRScanner />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <AttendanceTracker />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="analytics"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <AnalyticsDashboard />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="announcements"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingSpinner />}>
                <AnnouncementComposer />
              </Suspense>
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}
